<template>
    <div class="pending">
        <NoData v-if="pending.length<=0" :isTrade="isTrade"></NoData>
        <ul v-else>
            <li v-for="item in pending" @click="goPendingChart(item.SName.uiCodeID,item.ID)">
                <div class="itemTit">
                    <div class="leftCon"><span v-if="item.SName">{{item.SName.szShortName}}</span><p>#{{item.ID}}</p></div>
                    <div class="rightCon">
                        <div class="item" v-if="item.StopLoss && Number(item.StopLoss) != 0"><img src="@/assets/images/template/icon_pic_stoploss.png"/><span>{{$t('trade.products.stopLoss')}}</span></div>
                        <div class="item" v-if="item.TakeProfit && Number(item.TakeProfit) !=0 "><img src="@/assets/images/template/icon_pic_tar.png"/><span>{{$t('trade.products.stopProfit')}}</span></div>
                    </div>
                </div>
                <div class="itemCon">
                    <div class="leftCon">
                        <div class="itemList">
                            <div class="item"><em :class="cutover(tradeUtil.OrderDirection[item.Direction])">{{tradeUtil.OrderDirection[item.Direction]}}</em><p>{{item.RequestVolume}}</p></div>
                            <div class="item width"><span>{{$t('success.pendingPrice')}}</span><p>{{item.RequestPrice}}</p></div>
                        </div>
                        <div class="itemList">
                            <div class="item"><time>{{item.RequestTime|time}}</time></div>
                            <div class="item width"><p>{{item.ExpireType == 1?$t('trade.products.dayWeek'):$t('trade.products.validWeek')}}</p></div>
                        </div>
                    </div>
                    <div class="rightCon">
                        <div class="item"><span v-if="item.SName">{{quote.symbolTickMap[item.SName.szShortName][item.Direction == 1?'bid':'ask']}}</span></div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import moment from 'moment'
    import {mapState} from 'vuex'
    import TradeUtil from '@/utils/tradeUtil'
    import Util from '@/utils/tradeDataUtil'
    import NoData from '@/view/module/NoData.vue'
    export default {
        filters: {
            time(longTime) {
                return moment(new Date(longTime*1000)).format("YYYY-MM-DD HH:mm:ss");
            }
        },
        components:{NoData},
        computed: {
            ...mapState(['tradeData','quote']),
            pending:{
                get(){
                    return this.tradeData.pending;
                }
            }
        },
        data(){
            return {
                util:Util,
                tradeUtil:TradeUtil,
                isTrade:true
            }
        },
        methods:{
            goPendingChart(codeId,id) {
                this.$bus.$emit('loading', false);
                this.$router.push({path: '/home/pendingChart',query: {codeId: codeId,pendId:id}})
            },
            cutover:function(obj){
                let val;
                if (obj==this.$t('trade.products.buy')){
                    val="buy"
                }else if(obj==this.$t('trade.products.sell')){
                    val="sell"
                }
                return val;
            },
        }
    }
</script>
